import React from 'react';
import { CubeAnimation } from '../../testsuite/components/cube_animation';


const RheaLoader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <CubeAnimation lineWidth={10} color="var(--rhea-accent-primary)"/>
    </div>
  );
};

export default RheaLoader;
